import {
    RaceAdditionalPricingItem,
    RaceCommercialItem,
    RaceRegistrationResultDto,
    RegisterToRaceFormType,
    WspayConfirmation
} from "@model";

export function totalAmount(formType: RegisterToRaceFormType, calculationResponse?: RaceRegistrationResultDto,
                 registerToRaceResponse?: RaceRegistrationResultDto,
                 wspayConfirmation?: WspayConfirmation): number {

    switch (formType) {
        case RegisterToRaceFormType.PAYMENT:
            return wspayConfirmation?.totalAmountWithDiscount ?? 0;
        case RegisterToRaceFormType.CONFIRMATION:
            return registerToRaceResponse?.totalAmountWithDiscount ?? 0;
        case RegisterToRaceFormType.REGISTRATION_INFO:
            return calculationResponse?.totalAmountWithDiscount ?? 0;
        default:
            return 0;
    }
}

export function subTotalAmount(formType: RegisterToRaceFormType, calculationResponse?: RaceRegistrationResultDto,
    registerToRaceResponse?: RaceRegistrationResultDto,
    wspayConfirmation?: WspayConfirmation
): number {
    let total = 0;
    let traceyFee = 0;
    switch (formType) {
        case RegisterToRaceFormType.PAYMENT:
            total = wspayConfirmation?.totalAmount ?? 0;
            traceyFee = wspayConfirmation?.traceyFee ?? 0;
            break;
        case RegisterToRaceFormType.CONFIRMATION:
            total = registerToRaceResponse?.totalAmount ?? 0;
            traceyFee = registerToRaceResponse?.traceyFeeAmount ?? 0;
            break;
        case RegisterToRaceFormType.REGISTRATION_INFO:
            total = calculationResponse?.totalAmount ?? 0;
            traceyFee = calculationResponse?.traceyFeeAmount ?? 0;
            break;
        default:
            break;
    }
    ///in cents because of floating point precision errors
    const totalCents = Math.round(total * 100);
    const traceyFeeCents = Math.round(traceyFee * 100);
    return (totalCents - traceyFeeCents) !== 0 ? (totalCents - traceyFeeCents) / 100 : 0;
}

export function totalAmountWithoutFee(
    formType: RegisterToRaceFormType,
    calculationResponse?: RaceRegistrationResultDto,
    registerToRaceResponse?: RaceRegistrationResultDto,
    wspayConfirmation?: WspayConfirmation
): number {
    const total = totalAmount(formType, calculationResponse, registerToRaceResponse, wspayConfirmation);
    let traceyFee = 0;
    switch (formType) {
        case RegisterToRaceFormType.PAYMENT:
            traceyFee = wspayConfirmation?.traceyFee ?? 0;
            break;
        case RegisterToRaceFormType.CONFIRMATION:
            traceyFee = registerToRaceResponse?.traceyFeeAmount ?? 0;
            break;
        case RegisterToRaceFormType.REGISTRATION_INFO:
            traceyFee = calculationResponse?.traceyFeeAmount ?? 0;
            break;
        default:
            break;
    }
    const totalCents = Math.round((total ?? 0) * 100);
    const traceyFeeCents = Math.round(traceyFee * 100);
    return (totalCents - traceyFeeCents) / 100;
}

export function discountAmount(
    formType: RegisterToRaceFormType,
    calculationResponse?: RaceRegistrationResultDto,
    registerToRaceResponse?: RaceRegistrationResultDto,
    wspayConfirmation?: WspayConfirmation
): number {

    let totalCents = 0;
    let discountCents = 0;

    switch (formType) {
        case RegisterToRaceFormType.PAYMENT:
            totalCents = Math.round((wspayConfirmation?.totalAmount ?? 0) * 100);
            discountCents = Math.round((wspayConfirmation?.totalAmountWithDiscount ?? 0) * 100);
            break;
        case RegisterToRaceFormType.CONFIRMATION:
            totalCents = Math.round((calculationResponse?.totalAmount ?? 0) * 100);
            discountCents = Math.round((calculationResponse?.totalAmountWithDiscount ?? 0) * 100);
            break;
        case RegisterToRaceFormType.REGISTRATION_INFO:
            totalCents = Math.round((calculationResponse?.totalAmount ?? 0) * 100);
            discountCents = Math.round((calculationResponse?.totalAmountWithDiscount ?? 0) * 100);
            break;
        default:
            break;
    }
    return (discountCents - totalCents) !== 0 ? (discountCents - totalCents) / 100 : 0;
}


export function traceyFeeAmount(
    formType: RegisterToRaceFormType,
    calculationResponse?: RaceRegistrationResultDto,
    registerToRaceResponse?: RaceRegistrationResultDto,
    wspayConfirmation?: WspayConfirmation
): number {
    switch (formType) {
        case RegisterToRaceFormType.PAYMENT:
            return wspayConfirmation?.traceyFee ?? 0;
        case RegisterToRaceFormType.CONFIRMATION:
            return registerToRaceResponse?.traceyFeeAmount ?? 0;
        case RegisterToRaceFormType.REGISTRATION_INFO:
            return calculationResponse?.traceyFeeAmount ?? 0;
        default:
            return 0;
    }
}


export function hasAnyPrice(
    raceCommercialItem: RaceCommercialItem | RaceCommercialItem[] | undefined,
    additionalPricingItems: RaceAdditionalPricingItem[] | undefined
): boolean {

    const commercialItems = Array.isArray(raceCommercialItem)
        ? raceCommercialItem
        : raceCommercialItem ? [raceCommercialItem] : [];

    for (const item of commercialItems) {
        if (item.periods?.length) {
            const periodHasPrice = item.periods.some(period => period.price != null && period.price !== 0);
            if (periodHasPrice) {
                return true;
            }
        }
        if (item.price != null && item.price !== 0) {
            return true;
        }
    }

    if (Array.isArray(additionalPricingItems)) {
        for (const item of additionalPricingItems) {
            if (item?.price != null && item.price !== 0) {
                return true;
            }

            if (Array.isArray(item?.pricingItemValues)) {
                for (const value of item.pricingItemValues) {
                    if (value?.price != null && value.price !== 0) {
                        return true;
                    }
                }
            }
        }
    }

    return false;
}

